import PropTypes from 'prop-types'
import { useTranslation } from 'next-i18next'

// Internal Components
import CalendarMenu from '../CalendarMenu/CalendarMenu'
import { useContext } from 'react'
import { UserContext } from '../../context/UserContext'

const CalendarBlueprint = (props) => {
  const { id, title, cardRef, preview } = props

  const userContext = useContext(UserContext)

  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  return (
    <>
      <div className="CalendarBlueprint">
        {title && (
          <div className="CalendarBlueprint-heading">
            <h3 className="CalendarBlueprint-title">{title}</h3>
          </div>
        )}
        {!preview && (
          <CalendarMenu
            menu={[
              {
                label: t('CALENDAR_MENU__REMOVE_BLUEPRINT'),
                modal: {
                  type: 'api',
                  route: 'delete/blueprint-from-calendar',
                  id: id
                }
              }
            ]}
            modifiers={['CalendarMenu--blueprint']}
            cardRef={cardRef}
          />
        )}
      </div>
      <div className="CalendarBlueprint-background" />
    </>
  )
}

CalendarBlueprint.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  menu: PropTypes.array,
  cardRef: PropTypes.object,
  preview: PropTypes.bool
}

export default CalendarBlueprint
